import React, { useState } from 'react'
import { Icon, ListItem, Menu } from '@material-ui/core'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
import {
  fetchLookupTablesData,
  setIsLoading,
} from 'reducers/lookupTables/reducer'
import { ReactComponent as DeleteJobIcon } from 'assets/img/management-delete-job-icon.svg'
import { getFormattedDate } from 'helpers/dates'
import * as ROUTE from 'constants/appRouting'
import {
  ACTION_PUBLISH,
  ACTION_UNPUBLISH,
  STATUS_DRAFT,
} from 'constants/lookupTables'
import {
  CREATED_OR_MODIFIED_BY_PROP_TYPE,
  REACT_INTL_PROP_TYPE,
} from 'constants/propTypes'
import UsersListComponent from 'components/common/UsersList/UsersList'
import messages from './translate'

function TableItem({
  intl: { formatMessage },
  history,
  id: tableId,
  tablesListPsfs,
  title,
  status,
  createdBy,
  dateCreated,
  modifiedBy,
  dateUpdated,
  setTableContextMenuPosition,
  setConfirmDialogSettings,
  setIsDialogOpened,
  onConfirmTableAction,
  onConfirmDeleteTable,
  fetchLookupTablesData,
  setIsLoading,
  licensee: { usaDateFormat },
}) {
  const [tableContextMenuAnchor, setTableContextMenuAnchor] = useState(null)
  const isDraft = status === STATUS_DRAFT
  const actionName = isDraft ? ACTION_PUBLISH : ACTION_UNPUBLISH

  const onOpenTableContextMenu = (event, anchor) => {
    event.preventDefault()
    event.stopPropagation()
    setTableContextMenuPosition({
      left: event.pageX,
      top: event.pageY,
    })
    setTableContextMenuAnchor(anchor)
  }

  const onOpenDialog = (
    popupTitle,
    popupMessage,
    popupAction,
    confirmButtonText,
    confirmButtonColor,
  ) => {
    setIsDialogOpened(true)
    setTableContextMenuAnchor(null)
    setConfirmDialogSettings({
      popupAction,
      popupTitle,
      popupMessage,
      confirmButtonText,
      confirmButtonColor,
    })
  }
  const dateFormat = usaDateFormat ? 'MM-DD-YY' : 'DD-MM-YY'

  return (
    <>
      <div
        className="tables-list-item"
        onContextMenu={event => {
          onOpenTableContextMenu(
            event,
            document.querySelectorAll('.table-context-menu-anchor-el')[0],
          )
        }}
        onClick={() => {
          setIsLoading(true)
          history.push(`${ROUTE.LOOKUP_TABLES}/${tableId}`)
        }}>
        <div className="lookup-tables-col id-col">{tableId}</div>
        <div className="lookup-tables-col title-col">{title}</div>
        <div className="lookup-tables-col status-col">
          <span className={`status-label ${status}`}>
            {formatMessage(messages[status])}
          </span>
        </div>
        <div className="lookup-tables-col created-by-col">
          {!!createdBy && <UsersListComponent users={[createdBy]} />}
        </div>
        <div className="lookup-tables-col date-col">
          {getFormattedDate(dateCreated, dateFormat)}
        </div>
        <div className="lookup-tables-col created-by-col">
          {!!modifiedBy.length && <UsersListComponent users={modifiedBy} />}
        </div>
        <div className="lookup-tables-col date-col">
          {getFormattedDate(dateUpdated, dateFormat)}
        </div>
        <div className="lookup-tables-col configure-col">
          <Icon
            className="more-options-icon"
            onClick={event => {
              onOpenTableContextMenu(event, event.currentTarget)
            }}>
            more_vert
          </Icon>
        </div>
      </div>
      <Menu
        anchorEl={tableContextMenuAnchor}
        open={!!tableContextMenuAnchor}
        className="management-ui-menu"
        onClose={() => {
          setTableContextMenuAnchor(null)
        }}>
        <ListItem
          className="menu-item context-menu-item secondary"
          onClick={() => {
            onOpenDialog(
              formatMessage(messages[actionName]),
              <>
                {formatMessage(messages.lookupTableActionMessage, {
                  action: formatMessage(messages[actionName]),
                })}{' '}
                &quot;<strong>{title}</strong>&quot;?
              </>,
              () => {
                onConfirmTableAction(
                  tableId,
                  actionName,
                  () => {
                    fetchLookupTablesData({
                      psfs: tablesListPsfs,
                    })
                  },
                  formatMessage(messages.lookupTableActionSuccessMessage, {
                    action: formatMessage(messages[actionName]),
                  }),
                  formatMessage(messages.lookupTableActionErrorMessage, {
                    action: formatMessage(messages[actionName]),
                  }),
                )
              },
              actionName,
              isDraft ? 'scales-green' : 'scales-gray',
            )
          }}>
          {formatMessage(messages[actionName])}
        </ListItem>
        <ListItem
          className="menu-item context-menu-item"
          onClick={() => {
            onOpenDialog(
              formatMessage(messages.delete),
              <>
                {formatMessage(messages.deleteTableDialogMessage)} &quot;
                <strong>{title}</strong>&quot;?
              </>,
              () => {
                onConfirmDeleteTable(
                  tableId,
                  () => {
                    fetchLookupTablesData({
                      psfs: tablesListPsfs,
                    })
                  },
                  formatMessage(messages.deleteTableSuccessMessage),
                  formatMessage(messages.deleteTableErrorMessage),
                )
              },
              'delete',
              'scales-secondary',
            )
          }}>
          <DeleteJobIcon />
          {formatMessage(messages.delete)}
        </ListItem>
      </Menu>
    </>
  )
}

TableItem.propTypes = {
  intl: REACT_INTL_PROP_TYPE.isRequired,
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  createdBy: CREATED_OR_MODIFIED_BY_PROP_TYPE,
  dateCreated: PropTypes.string.isRequired,
  modifiedBy: PropTypes.arrayOf(CREATED_OR_MODIFIED_BY_PROP_TYPE).isRequired,
  dateUpdated: PropTypes.string.isRequired,
  setTableContextMenuPosition: PropTypes.func.isRequired,
  setConfirmDialogSettings: PropTypes.func.isRequired,
  setIsDialogOpened: PropTypes.func.isRequired,
  fetchLookupTablesData: PropTypes.func.isRequired,
  onConfirmTableAction: PropTypes.func.isRequired,
  onConfirmDeleteTable: PropTypes.func.isRequired,
  setIsLoading: PropTypes.func.isRequired,
}

TableItem.defaultProps = {
  createdBy: null,
}

export default connect(
  state => ({
    tablesListPsfs: state.getIn(['lookupTables', 'tablesListPsfs']),
    licensee: state.getIn(['profile', 'profile', 'licensee']),
  }),
  {
    fetchLookupTablesData,
    setIsLoading,
  },
)(injectIntl(TableItem))
